import { Controller } from "@hotwired/stimulus";
import { handleHttpResponse } from "../../utils/http_utils";
import { closeModal } from "../../utils/misc";
import { originalResponseFromTurboResponseEvent } from "../../utils/turbo_utils";

export default class extends Controller {
  onOtpConfigurationChanged(event) {
    handleHttpResponse({
      payload: originalResponseFromTurboResponseEvent(event),
      onSuccess: () => {
        closeModal(this.element.id);
      },
      onError: () => {
        return false;
      },
    });
  }
}
